import React, { Fragment } from 'react';
import ManageDynamicReports from './ManageDynamicReports';

// Thin route entry — the V3 shell lives inside the view.
const DynamicReports = () => (
    <Fragment>
        <ManageDynamicReports />
    </Fragment>
);

export default DynamicReports;
